import { Component } from "react"
import Birthday from "./Birthday"
import Email from "./Email"
import HomePage from "./HomePage"
import TwitterId from "./TwitterId"
import InstagramId from "./InstagramId"
import Password from "./Password"
import ProfileImage from "./ProfileImage"
import SelfIntroduction from "./SelfIntroduction"
import OnetimePassword from "./OnetimePassword"
import Sex from "./Sex"
import UserName from "./UserName"

type Props = {
    email:Email,password:Password,userName:UserName,homePage:HomePage,twitterId:TwitterId,
    instagramId:InstagramId,sex:Sex,birthday:Birthday,selfIntroduction:SelfIntroduction,onetimePassword:OnetimePassword,profileImage:ProfileImage
}
class RegistInfo extends Component {
    private _email: Email
    private _password: Password
    private _userName: UserName
    private _homePage: HomePage
    private _twitterId: TwitterId
    private _instagramId: InstagramId
    private _sex: Sex
    private _birthday: Birthday
    private _selfIntroduction: SelfIntroduction
    private _onetimePassword: OnetimePassword
    private _profileImage: ProfileImage

    constructor(props:Props){
        super(props)
        this._email = props.email
        this._password = props.password
        this._userName = props.userName
        this._homePage = props.homePage
        this._twitterId = props.twitterId
        this._instagramId = props.instagramId
        this._sex = props.sex
        this._birthday = props.birthday
        this._selfIntroduction = props.selfIntroduction
        this._onetimePassword = props.onetimePassword
        this._profileImage = props.profileImage
    }

    public get values() {
        return {
            email:this.email.props,
            password:this.password.props,
            userName:this.userName.props,
            homePage:this.homePage.props,
            twitterId:this.twitterId.props,
            instagramId:this.instagramId.props,
            sex:this.sex.props,
            birthday:this.birthday.props,
            selfIntroduction:this.selfIntroduction.props,
            onetimePassword:this.onetimePassword.props,
            profileImage:this.profileImage.props
        }
    }

    validate(callbackDialog): boolean {
        return this.profileImage.validate(callbackDialog,true) && this.email.validate(callbackDialog,true)
            && this.password.validate(callbackDialog,true) && this.userName.validate(callbackDialog,true)
            && this.homePage.validate(callbackDialog,false) && this.twitterId.validate(callbackDialog,false)
            && this.instagramId.validate(callbackDialog,false) && this.sex.validate(callbackDialog,true)
            && this.birthday.validate(callbackDialog,true) && this.selfIntroduction.validate(callbackDialog,false)
            && this.onetimePassword.validate(callbackDialog,true)
    }

    public get email(): Email {
        return this._email
    }
    public get password(): Password {
        return this._password
    }
    public get userName(): UserName {
        return this._userName
    }
    public get homePage(): HomePage {
        return this._homePage
    }
    public get twitterId(): TwitterId {
        return this._twitterId
    }
    public get instagramId(): InstagramId {
        return this._instagramId
    }
    public get sex(): Sex {
        return this._sex
    }
    public get birthday(): Birthday {
        return this._birthday
    }
    public get selfIntroduction(): SelfIntroduction {
        return this._selfIntroduction
    }
    public get onetimePassword(): OnetimePassword {
        return this._onetimePassword
    }
    public get profileImage(): ProfileImage {
        return this._profileImage
    }
}

export default RegistInfo;